import {useAppDispatch, useAppSelector} from '@lib/store';
import {actions} from '@lib/store/src/data/timeslots/actions';
import {WorkspaceReservation} from '@lib/store/src/data/timeslots/apiTypes';
import {useEffect} from 'react';
import {getAttendeeOverview, ReservationDetails} from '../../../data/timeslots/selectors/getAttendeeOverview';

// This hook waits for all details to be loaded before exposing the data
// Basically assuming we'll get an endpoint that returns all of this in one go later.
// In the meantime, if you want a nice gradual load where you first show the reservations and later fill in
// owners, you can do so through custom selectors (after dispatching loadReservationDetails)
export const useReservationDetails = (workspaceReservation: WorkspaceReservation | null): ReservationDetails => {
  const dispatch = useAppDispatch();

  useEffect(
    function ensureDetailsAreLoaded() {
      if (workspaceReservation) {
        dispatch(actions.loadReservationDetails({workspaceReservation}));
      }
    },
    [workspaceReservation],
  );

  // Construct
  const viewmodel = useAppSelector((state) => getAttendeeOverview(state, workspaceReservation));

  return viewmodel;
};
